import "./index.scss"
import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function FeatureCard({ featureData, handleModal }) {
  const {
    intro,
    button,
    headline,
    hasVideo,
    videoLink,
    featureTag,
    background,
    videoSource,
    boxAlignment,
    featuredImage,
    textBorderColor,
  } = featureData

  const img = getImage(featuredImage[0].featuredImage)
  const link = button[0]
  const bgColor = background[0].backgroundColor

  return (
    <div className="feature-card-wrapper" style={{ backgroundColor: bgColor }}>
      {background[0].hasBackgroundImage && (
        <GatsbyImage
          image={getImage(background[0].image)}
          className="bg-image"
        />
      )}
      <div className="container">
        <div
          className={`row ${boxAlignment === "right" && "justify-content-end"}`}
        >
          <div className="col-md-10">
            <div
              className={`feature-card-solo feature-card ${
                hasVideo && "video-card"
              } ${boxAlignment}`}
              data-vidsource={videoSource}
              data-vidlink={videoLink}
              data-hasvid={hasVideo}
              onClick={e => handleModal(e)}
            >
              <div className="feature-card__image">

                <Link to={link.linkUrl}>
                  <GatsbyImage image={img} alt={headline} />
                </Link>
                {hasVideo && (
                  <div className="modal-click-overlay">
                    <svg
                      width="81"
                      height="82"
                      viewBox="0 0 81 82"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_254_8325)">
                        <rect
                          x="24"
                          y="24"
                          width="34"
                          height="34"
                          fill="#FD4A5C"
                        />
                        <path
                          d="M40.5 4C20.3435 4 4 20.5674 4 41C4 61.4326 20.3435 78 40.5 78C60.6565 78 77 61.4326 77 41C77 20.5674 60.6565 4 40.5 4ZM52.2403 41.5699L34.4465 54.6933C34.349 54.7644 34.234 54.8068 34.1142 54.8159C33.9944 54.825 33.8745 54.8005 33.7675 54.745C33.6606 54.6896 33.5708 54.6053 33.5081 54.5014C33.4453 54.3976 33.412 54.2782 33.4118 54.1565V27.9261C33.4114 27.8041 33.4444 27.6844 33.507 27.5802C33.5696 27.476 33.6595 27.3914 33.7667 27.3358C33.8738 27.2802 33.994 27.2558 34.114 27.2652C34.2341 27.2747 34.3491 27.3176 34.4465 27.3893L52.2403 40.5045C52.3244 40.5647 52.3929 40.6446 52.4403 40.7373C52.4876 40.8299 52.5123 40.9328 52.5123 41.0372C52.5123 41.1415 52.4876 41.2444 52.4403 41.3371C52.3929 41.4298 52.3244 41.5096 52.2403 41.5699Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_254_8325"
                          x="0"
                          y="0"
                          width="81"
                          height="82"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_254_8325"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_254_8325"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                )}
              </div>

              <Link to={link.linkUrl}>
                <div
                  className={`feature-card__data ${
                    "border-" + textBorderColor.replace("#", "")
                  }`}
                >
                  {featureTag != "" && <span>{featureTag}</span>}
                  <h3 className="oblique text-white">{headline}</h3>
                  <p>{intro}</p>
                  <Link to={link.linkUrl} className="btn btn-primary">
                    {link.label}
                  </Link>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
